<template lang="pug">
  v-layout(row wrap)
    v-flex(xs12)
      Navbar(:backButtonPath="'/home'")

    responsive-flex
        fan-loader(
          :loading="loading"
          :empty="!historyExists"
          :class="$vuetify.breakpoint.smAndUp ? 'my-4' : null"
        )
          div(slot="loadingMsg"
            class="full-width text-xs-center headline my-2"
          ) Loading Application History...
        
        div(v-if="!loading && applications !== null && !hasGreenskyAndCheckingForPrequal")
          v-tabs(
            :class="'tabs'"
            v-if="$vuetify.breakpoint.smAndUp"
            v-model="tabSelected"
            centered
            show-arrows
            hide-slider
            grow
            height="50px"
          )
            v-tab(
              v-if="$vuetify.breakpoint.smAndUp"
              v-for="tab in tabsArray"
              :key="tab.code"
            )
              | {{ tab.name}}
              span(class="list-count") {{ tab.count }}

          div.mt-2(v-else class="tabs-mobile")
            v-btn.ma-0.pa-0(flat color="primary" @click="back()" :disabled="disabledLeft")
              v-icon chevron_left
            span.tabs-mobile-text {{ currentTab }}
            v-btn.ma-0.pa-0(flat color="primary" @click="next()" :disabled="disabledRight")
              v-icon chevron_right

        
          //Leads tab
          v-tabs-items(
            v-model="tabSelected"
          )
            v-tab-item(
              v-for="tab in tabsArray"
              :key="tab.code"
            )
              leads-list(
                v-if="tab.code === 'leads'"
                :class="$vuetify.breakpoint.smAndUp ? 'mt-5' : ''"
              )
              
              PreQualificationsList(
                v-if="tab.code === 'preQuals'"
                :class="$vuetify.breakpoint.smAndUp ? 'mt-5' : ''"
              )

              div(v-if="tab.code === 'applications'")
                v-flex(xs12 sm8 :class="$vuetify.breakpoint.smAndUp ? 'mt-5' : ''")
                  v-text-field.px-4( 
                    outline
                    prepend-inner-icon="search"
                    label="Search Applications"
                    placeholder="Name, Application ID, Lender or Status"
                    v-model="searchInput"
                    @input="searchFromInput"
                  )
                    template(v-slot:append-outer='')
                      v-tooltip(bottom)
                        template(v-slot:activator="{ on }")
                          v-icon( v-on="on") mdi-information-outline
                        span {{ searchMessaging }}

                template( v-if="applicationsHistory.length < 1" )
                  h2 No Results
                template( v-else )
                  ApplicationsList(
                      :applications = "applicationsHistory" 
                      :searchInput = "searchInput"
                    )
</template>

<script>
  import * as JsSearch from 'js-search';
  import ApplicationsList from 'Components/ApplicationsList'
  import FanLoader from 'Components/FanLoader'
  import LeadsList from 'Components/LeadsList'
  import PreQualificationsList from 'Components/PreQualificationsList'
  import Navbar from 'Components/Navbar.vue'
  import ResponsiveFlex from 'Components/ResponsiveFlex.vue'
  import appVars from '@/app_vars'
  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {
    name: 'ApplicationHistory',
    data () {
      return {
        leadsListEnabled: appVars.leadsListEnabled,
        tabSelected: 0,
        filteredApplications: [],
        hasGreensky: null,
        loading: true,
        searchIndex: null,
        searchInput: null,
        searchMessaging: 'Search any application by Applicant Name, Application ID, Lender Name or Application Status',
        tabsName: []
      }
    },
    components: {
      ApplicationsList,
      FanLoader,
      LeadsList,
      PreQualificationsList,
      Navbar,
      ResponsiveFlex,
    },
    computed: {
      ...mapState({
        leads: state => state.user.easyLinkLeads,
        applications: state => state.user.applicationHistory,
        preQualApplications: state => state.user.preQualApplicationHistory,
        dealerId: state => state.user.dealerId,
        hasGreenskyPreQual: state => state.user.hasGreenskyPreQual,
        userEmail: state => state.user.email,
        userLastName: state => state.user.lastName
      }),
      ...mapGetters([
        'availableLenders',
      ]),
      hasGreenskyAndCheckingForPrequal(){
        return this.hasGreensky && this.hasGreenskyPreQual === null
      },
      historyExists () {
        return (this.applications !== null
          && this.applications.length > 0)
          || this.leads.length > 0
      },
      applicationsHistory() {
        return this.searchInput
          ? this.sortedApplications()
          : this.applications
      },
      totalApplications() {
        return (this.applications !== null)
          ? this.applications.length
          : ''
      },
      currentTab() {
        return this.tabsName[this.tabSelected]
      },
      tabsArray(){
        let tabs = []
        if(this.leadsListEnabled) {
          tabs.push({code: 'leads', name: 'Leads', count: this.leads.length})
          this.addTabsName('Leads')
        }
        if(this.hasGreenskyPreQual) {
          tabs.push({code: 'preQuals', name: 'Prequalifications', count: this.preQualApplications.totalSummaries})
          this.addTabsName('Prequalifications')
        }
        if(this.applications) {
          tabs.push({code: 'applications', name: 'Applications', count: this.totalApplications})
          this.addTabsName('Applications')
        }
        return tabs
      },
      disabledLeft(){
        if(this.tabSelected > 0){
          return false
        } else {
          return true
        }
      },
      disabledRight(){
        let counter = this.tabsName.length - 1
        if(this.tabSelected < counter){
          return false
        } else {
          return true
        }
      }
    },
    methods: {
      ...mapActions(['loadApplicationHistory', 'loadEasyLinkLeads', 'getUserInfo', 'loadPreQualApplicationHistory', 'greenskyValidation', 'decideIfHasGreenskyPreQual', 'error' ]),
      buildSearchIndex() {
        this.searchIndex = new JsSearch.Search('application_id');
        this.searchIndex.addIndex('application_id')
        this.searchIndex.addIndex('applicant_first_name');
        this.searchIndex.addIndex('applicant_last_name');
        this.searchIndex.addIndex('lender');
        this.searchIndex.addIndex('lenderName');
        this.searchIndex.addIndex('application_status');
        this.searchIndex.addDocuments(this.applications)
      },
      addLenderNameToApplicationIndexes(applications) {
        applications.map(app => {
          switch (app.lender) {
            case 'greensky':
              app.lenderName = 'Green Sky'
              break
            case 'wellsfargo':
              app.lenderName = 'Wells Fargo'
              break
            case 'customfin':
              app.lenderName = 'Custom Fin'
              break
          }
          return app
        })
      },
      searchFromInput() {
        this.filteredApplications = this.searchIndex.search(this.searchInput);
      },
      sortedApplications() {
        return this.filteredApplications.sort(function(a,b) {
          return new Date(b.application_date) - new Date(a.application_date)
        })
      },
      addTabsName(name) {
        if(!this.tabsName.includes(name)) this.tabsName.push(name)
      },
      next() {
        let counter = this.tabsName.length - 1
        if(this.tabSelected < counter) this.tabSelected += 1
      },
      back() {
        if(this.tabSelected > 0) this.tabSelected -= 1
      }
    },
    async mounted() {
      try {
        this.decideIfHasGreenskyPreQual(null)
        await this.getUserInfo()
        const greenskyMerchantId = this.availableLenders.filter(lender => lender.active).find( l => l.lender_id === '1')
        if(greenskyMerchantId){
          this.hasGreensky = true
          const payload = {
            merchantId: greenskyMerchantId.merchant_id,
            email: this.userEmail,
            lastName: this.userLastName
          }
          await this.greenskyValidation(payload)
        }
        await this.loadApplicationHistory()
        await this.addLenderNameToApplicationIndexes(this.applications)
        await this.buildSearchIndex()
        await this.loadEasyLinkLeads()
        if (!this.leadsListEnabled) this.tabSelected = '0'
        this.loadPreQualApplicationHistory({
          limit: 6,
          page: 1,
          dealerId: this.dealerId
        })
        this.loading = false
      } catch (error) {
        console.log('ApplicationHistory: ',error)
        this.error(error.message)
        this.loading = false
      }
    },
  }
</script>

<style lang="stylus">
  @import '~vuetify/src/stylus/main'

  .list-count {
    @extends .subheading;
    @extends .ml-2;
    font-weight: 900;
  }
</style>

<style lang="scss" scoped>

  .tabs-mobile-text {
    display: inline-block;
    width: 200px;
    text-transform: uppercase;
  }
  
  .tabs-mobile {
    width: 100%;
    min-width: 300px;
  }

  .v-btn {
    min-width: 50px;
  }

  .tabs ::v-deep .v-tabs__item {
    background: #989898;
    color: white;
  }

  .tabs ::v-deep  .v-tabs__item--active {
    background: #3A83F6;
  }

  .tabs ::v-deep .v-tabs__item:not(.v-tabs__item--active) {
    height: 70% !important;
  }

</style>